
<template>
  <div class="fts-listing-design">
    <draggable
      handle=".listing-wrapper-handle"
      draggable=".listing-wrapper"
      v-model="mutableValue"
      v-bind="dragOptions"
      class="listing-container"
      :class="[
        { 'listing-container--table': isTableColumns },
        { 'fts-scrollbar': !isTableColumns }
      ]"
    >
      <fts-listing-column-design
        v-for="(x, index) in mutableValue"
        :key="x.id"
        :modules="modules"
        :options="options"
        :selected-options="getSelectedOptions"
        :form-data="mutableValue[index]"
        @shortcut-option:selected="(option) => addOptionToList(option, index)"
        @option:remove="(option) => removeOption(option, index)"
        @action:manage="openActionDesignModal"
        class="listing-wrapper"
      />

      <div
        slot="footer"
        class="listing-actions"
        :class="{'listing-actions--sticky': mutableValue && mutableValue.length }"
      >
        <fts-form-design-shortcut
          :modules="modules"
          :options="options"
          :selected-options="getSelectedOptions"
          disable-create
          class="listing-action"
          @option:selected="(option) => addOptionToList(option)"
        >
          <fts-tippy>
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width />
            <div slot="content" class="tippy-hint">
              <span class="tippy-hint-highlight">Click</span> to add a field
            </div>
          </fts-tippy>
        </fts-form-design-shortcut>
      </div>
    </draggable>
    <!-- listing action design modal -->
    <fts-listing-action-design-modal ref="ftsListingActionDesignModal" />
  </div>
</template>

<script>
import draggable from 'vuedraggable';

import commons from '../commons/commons';

import FTSTippy from '../elements/FTSTippy';
import FTSDropdownSelect from '../elements/FTSDropdownSelect';
import FTSListingColumnDesign from './FTSListingColumnDesign';
import FTSListingActionDesignModal from './FTSListingActionDesignModal';
import FTSFormDesignShortcut from './FTSFormDesignShortcut';

export default {
  components: {
    draggable,
    "fts-tippy": FTSTippy,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-listing-column-design": FTSListingColumnDesign,
    "fts-form-design-shortcut": FTSFormDesignShortcut,
    "fts-listing-action-design-modal": FTSListingActionDesignModal
  },
  props: {
    modules: Array,
    activities: Array,
    documents: Array,
    actions: Array,
    options: Array,
    selectedOptions: Array,
    list: Array,
    isTableColumns: Boolean
  },
  data: () => ({
    dragOptions: commons.dragOptions
  }),
  methods: {
    addOptionToList(option, index) {
      if (this.isTableColumns) {
        const columnIndex = this.mutableValue.findIndex((x) => x.id === option.id);
        if (columnIndex > -1) {
          this.$set(this.mutableValue, columnIndex, { ...option, hide: false });
        }
      } else {
        const columnIndex = (
          index == null ||
          index == undefined
        ) ? this.mutableValue.length : index + 1;
        this.mutableValue.splice(columnIndex, 0, option);

        if (option.id === 'action') {
          this.openActionDesignModal(option);
        }
      }
    },
    removeOption(option, index) {
      if (this.isTableColumns) {
        const columnIndex = this.mutableValue.findIndex((x) => x.id === option.id);
        if (columnIndex > -1) {
          this.$set(this.mutableValue, columnIndex, { ...option, hide: true });
        }
      } else {
        this.mutableValue.splice(index, 1);
      }
    },
    async openActionDesignModal(formData) {
      const res = await this.$refs.ftsListingActionDesignModal.show(
        formData,
        {
          activities: this.activities,
          documents: this.documents,
          actions: this.actions
        }
      );
      if (res === true) {
        const columnIndex = this.mutableValue.findIndex((x) => x.id === res.id);
        if (columnIndex > -1) {
          this.mutableValue.splice(columnIndex, 1);
        }
      } else if (res) {
        const columnIndex = this.mutableValue.findIndex((x) => x.id === res.id);
        if (columnIndex > -1) {
          this.$set(this.mutableValue, columnIndex, res);
        }
      }
    }
  },
  computed: {
    mutableValue: {
      get() {
        return this.list;
      },
      set(val) {
        this.$emit('update:list', val);
      }
    },
    getSelectedOptions() {
      return this.selectedOptions || this.mutableValue;
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-listing-design {
  .listing-container {
    display: flex;
    border: 1px solid var(--fts-border);
    &.listing-container--table {
      border-left: 0;
    }
  }
  .listing-wrapper {
    border-right: 1px solid var(--fts-border);
  }
  .listing-actions {
    background-color: var(--fts-card-background);
    .listing-action {
      padding: 0.5rem 0.75rem;
      font-size: 0.75rem;
      line-height: 1.25rem;
      color: var(--fts-default);
    }
    &.listing-actions--sticky {
      position: sticky;
      right: 0;
    }
  }
}
</style>